import React, { useState } from 'react'
import styled from 'styled-components'
import { useGlobalLabels } from '@sentecacommerce-theme/lib'
import { ModalProps } from '../../Modal'
import { EditBillingAddress } from '../EditBillingAddress'
import dynamic from 'next/dynamic'

const Modal = dynamic<ModalProps>(
  () => import('../../Modal').then((mod) => mod.Modal),
  {
    ssr: false,
  }
)

export const BillingAddressPreview = ({
  data,
  isSelectable,
  isSelected,
  onChange,
  hideRemove,
  labels,
}: BillingAddressPreviewProps) => {
  // const [mutate] = companiesApi.useRemove()
  const [isEditing, setIsEditing] = useState(false)
  const { company } = useGlobalLabels()
  // const removeBillingAddress = (
  //   e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  // ) => {
  //   e.stopPropagation()

  //   data._id &&
  //     mutate({
  //       id: data._id,
  //     })
  // }

  const getCustomField = (fieldName: string) => {
    const customFields = data.custom

    return (
      customFields?.find((customField) => customField.field === fieldName)
        ?.value || ''
    )
  }

  const openEditForm = (e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e?.stopPropagation()
    setIsEditing(true)
  }

  const closeEditForm = () => {
    setIsEditing(false)
  }

  const mol = getCustomField('mol')

  return (
    <Relative>
      <Container
        isSelected={isSelected}
        isSelectable={isSelectable}
        onClick={() => onChange?.()}
      >
        <Group>
          <ul>
            {data.isDefaultBillingAddress && (
              <PrimaryTitle>{labels?.primaryCompanyLabel}</PrimaryTitle>
            )}
            <li>{data.company.companyName}</li>
            <li>{data.streetName}</li>
            <li>{`${company?.vat}: ${data.company.vatId}`}</li>
            <li>{`${company?.companyId}: ${data.company.companyId}`}</li>
            {mol && <li>{`${company?.mol}: ${mol}`}</li>}
          </ul>
        </Group>
        {isEditing && (
          <Modal handleClose={closeEditForm} open={isEditing} noTitlePadding>
            <EditBillingAddress
              data={data}
              onCancel={closeEditForm}
              onSuccess={closeEditForm}
            />
          </Modal>
        )}
        {isSelectable && <Check isSelected={isSelected} />}
      </Container>
      {!hideRemove && (
        <EditButton onClick={openEditForm}>{labels?.editLabel}</EditButton>
      )}
    </Relative>
  )
}

type Props = {
  isSelectable?: boolean
  isSelected?: boolean
  onChange?: () => void
  hideRemove?: boolean
}

export type BillingAddressPreviewProps = Props & {
  labels: {
    editLabel?: string
    primaryCompanyLabel?: string
  }
  data: {
    company: {
      companyName: string
      vatId: string
      companyId: string
    }
    isDefaultBillingAddress: boolean
    streetName: string
    _id: string
    custom: [
      {
        field: 'mol'
        value: string
      }
    ]
  }
}

const EditButton = styled.span.attrs({
  className: 'p-0',
})`
  min-height: 0;
  cursor: pointer;
  font-size: 1.2rem;
  position: absolute;
  top: 0;
  right: 0;
  color: ${({ theme }) => theme.palette.silverTree};
  text-decoration: underline;

  &:hover {
    background: transparent;
    opacity: 0.7;
  }
`

const PrimaryTitle = styled.li`
  font-weight: 500;
`

const Group = styled.div`
  font-weight: 300;

  font-size: 1.7rem;

  & li {
    margin-bottom: 0.7rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`
const Relative = styled.div`
  position: relative;
`

const Container = styled.article<Props & { isSelected?: boolean }>`
  ${(props) =>
    props.isSelectable &&
    `
      cursor: pointer;
      padding-left: 3rem;

      ${
        !props.isSelected &&
        `
        &:hover {
          opacity: 0.7;
        }
      `
      }
  `}
`

const Check = styled.div<{ isSelected?: boolean }>`
  width: 1.6rem;
  height: 1.6rem;
  border: 0.1rem solid ${({ theme }) => theme.palette.silverTree};
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  left: 0rem;
  top: 0.5rem;

  ${(props) =>
    props.isSelected &&
    `
      &:after {
        content: '';
        display: block;
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        background: ${props.theme.palette.silverTree};
      }
  `}
`
